import { render } from "./KnowledgeGuide.vue?vue&type=template&id=33d9c129&scoped=true"
import script from "./KnowledgeGuide.vue?vue&type=script&lang=js"
export * from "./KnowledgeGuide.vue?vue&type=script&lang=js"

import "./KnowledgeGuide.vue?vue&type=style&index=0&id=33d9c129&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d9c129"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBtn,QTabs,QTab,QScrollArea});
